import "./src/styles/global.css";
import CustomLayout from "./wrapPageElement";
import "./i18n";

export const wrapPageElement = CustomLayout;
